import ReactOnRails from 'react-on-rails-pro';

export const registerComponent = (name, component) => {
  if (ReactOnRails.registeredComponents().has(name)) {
    // oxlint-disable-next-line no-console
    console.warn(
      `Tried to register component with name ${name} which was already registered.`,
    );
    return;
  }

  ReactOnRails.register({ [name]: component });
};
